import React, { useState } from "react";

import SaveButton from "../../../../../CommonComponents/SaveButton/SaveButton";
import CustomDragAndDrop from "../../../../../CommonComponents/CustomDragAndDrop/CustomDragAndDrop";

import "./stylesEditGameIconPopup.css";

import { Image, message } from "antd";
import { X } from "react-feather";

function EditGameIconPopup({ isVisible, game, onClosePressed, EditGameIcon }) {


  const [messageApi, contextHolder] = message.useMessage();
  const [iconBase64, setIconBase64] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);


  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!iconBase64) {
      messageApi.error("Please upload an icon");
      return;
    }

    const params = {
      image: iconBase64,
      game_id: game.game_id,
      provider: game.provider,
    };

    try {
      await EditGameIcon({...params});
    } catch (error) {
      console.error("Error updating game icon:", error);
      alert("Failed to update game icon. Please try again.");
    } finally {
      handleClose();
    }
  };

  const handleFileUpload = (base64) => {
    setIconBase64(base64);
  };

  const handleClose = () => {
    setIconBase64("");
    onClosePressed();
  };

  const onRemove = () => {
    setIconBase64("");
  };

  if (!isVisible) return null;

  return (
    <div className="edit-game-icon-popup">
      {contextHolder}
      <div className="edit-game-icon-panel">
        <div className="edit-game-icon-header">
          <h2>Edit Game Icon</h2>
          <button className="close-button" onClick={handleClose}>
            <X className="close-icon" />
          </button>
        </div>
        <div className="edit-game-icon-content">
          <CustomDragAndDrop
            onFileUpload={handleFileUpload}
            onRemove={onRemove}
          />
          {iconBase64 && (
            <div className="drag-drop-image-preview">
              <Image
                src={iconBase64}
                alt="Game Icon Preview"
                className="preview-img"
              />
            </div>
          )}
          <SaveButton
            isApiRunning={isSubmitting}
            buttonText="Save Icon"
            cancelButton={true}
            cancelButtonText="Cancel"
            callbackFunction={handleSubmit}
            callbackFunctionCancel={handleClose}
          />
        </div>
      </div>
    </div>
  );
}

export default EditGameIconPopup;
